import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, Mail, Zap, MapPin, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden" aria-label="UK Medico-Legal Assessments — independent, consultant-led medical reports for solicitors and insurers" data-id="element-240">
      {/* Background image */}
      <div className="absolute inset-0" data-id="element-241">
        <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&h=900&fit=crop&q=75" alt="Solicitor reviewing a medico-legal report at a professional desk with medical documentation and legal papers" className="w-full h-full object-cover" loading="eager" fetchPriority="high" data-id="element-242" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/[0.82] via-white/[0.65] to-teal-50/[0.35]" data-id="element-243" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-transparent to-white/30" data-id="element-244" />
      </div>

      {/* Subtle logo watermark */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-245">
        <img src="https://cdn.magicpatterns.com/uploads/cfHMrrPng3iagpRwV1FuNs/Favicon.jpg" alt="" aria-hidden="true" className="absolute -right-10 top-1/2 -translate-y-1/2 w-[500px] h-[500px] object-contain opacity-[0.04]" data-id="element-246" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 pt-32 pb-16 md:pt-40 md:pb-24" data-id="element-247">
        <div className="max-w-2xl" data-id="element-248">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-249">
            {/* Eyebrow badge */}
            <div className="badge mb-6" data-id="element-250">
              <Zap className="h-3.5 w-3.5 mr-1.5" data-id="element-251" />
              Urgent instructions accepted — reports from 1 week
            </div>

            {/* H1 */}
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] font-bold text-ink-900 leading-[1.08] tracking-tight mb-3" data-id="element-252">
              UK Medico-Legal Assessments
            </h1>

            {/* Strapline */}
            <p className="text-xl md:text-2xl font-semibold text-teal-600 mb-6 tracking-tight" data-id="element-253">
              Independent. Objective. Court-Ready.
            </p>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-ink-700 mb-10 leading-relaxed max-w-xl" data-id="element-254">
              We provide solicitors and insurers with consultant-led medical
              reports across all major clinical disciplines. From initial triage
              to final delivery, our process is governed by rigorous clinical
              scrutiny.
            </p>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-255">
              <a href="/contact" className="inline-flex items-center justify-center bg-teal-500 hover:bg-teal-600 active:bg-teal-700 text-white rounded-xl py-4 px-8 font-semibold shadow-sm transition-colors duration-200 text-base min-h-[52px] w-full sm:w-auto text-center" data-id="element-256">
                <FileCheck className="mr-2.5 h-5 w-5" data-id="element-257" />
                Submit Instruction
              </a>
              <a href="/contact" className="btn-secondary w-full sm:w-auto text-center" data-id="element-258">
                <Mail className="mr-2.5 h-5 w-5" data-id="element-259" />
                Contact Us
              </a>
            </div>

            {/* Inline trust points */}
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8" data-id="element-260">
              <div className="flex items-center text-sm font-semibold text-ink-700" data-id="element-261">
                <div className="w-8 h-8 rounded-lg bg-sage-50 flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-262">
                  <Zap className="h-4 w-4 text-sage-600" data-id="element-263" />
                </div>
                3–4 week turnaround
              </div>
              <div className="flex items-center text-sm font-semibold text-ink-700" data-id="element-264">
                <div className="w-8 h-8 rounded-lg bg-sage-50 flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-265">
                  <MapPin className="h-4 w-4 text-sage-600" data-id="element-266" />
                </div>
                UK-wide coverage
              </div>
              <div className="flex items-center text-sm font-semibold text-ink-700" data-id="element-267">
                <div className="w-8 h-8 rounded-lg bg-sage-50 flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-268">
                  <ShieldCheck className="h-4 w-4 text-sage-600" data-id="element-269" />
                </div>
                CPR Part 35 compliant
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}